import { render, staticRenderFns } from "./PrivacyModeDialog.vue?vue&type=template&id=1305cdb9&scoped=true"
import script from "./PrivacyModeDialog.vue?vue&type=script&lang=ts"
export * from "./PrivacyModeDialog.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyModeDialog.vue?vue&type=style&index=0&id=1305cdb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305cdb9",
  null
  
)

export default component.exports